export default {"src":"/_next/static/media/credit-badge-32percent.447b71ca.svg","height":81,"width":80,"blurWidth":0,"blurHeight":0};